import * as utils from "../../utils/utils.js";

export default function () {
  const widgetName = "fnManagedImage";
  const widgetOpts = fnManagedImageOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    hasImages: true,
    textOverImage: true,
    imageIsBackground: true,
    buyNowButton: false,
    lazyLoadImages: false,
    link: [""],
    moreButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`#${widgetName}`).remove();
      } else {
        createCustomManagedImage(data.items);
      }
    },
  });

  function createCustomManagedImage(widgetData) {
    const {  ImageWithPath, URL, ImageAlternateText } = widgetData[0];
    const isExternalURL =
      !utils.isLocalUrl(URL) && URL ? "target='_blank'" : "";

    $(`#${widgetName}`)
      .find(".card-widget-item")
      .replaceWith(
        `<a ${
          URL ? `href="${URL}"` : ""
        } aria-label="${ImageAlternateText}" ${isExternalURL} class="image-item ${
          !URL ? "voidLink" : ""
        }">
      <img src="${ImageWithPath}" alt="${ImageAlternateText}" title="${ImageAlternateText}">
      </a>`
      );
  }
}
